import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import ContractScheduleGanttFixture from './e2e/ContractScheduleGanttFixture';
import PostAwardOptionPlanningFixture from './e2e/PostAwardOptionPlanningFixture';
import DavisBaconScheduleFixture from './e2e/DavisBaconScheduleFixture';
import ConstructionCostSnapshotFixture from './e2e/ConstructionCostSnapshotFixture';
import ActualComponentQueueFixture from './e2e/ActualComponentQueueFixture';
import { installRemoteApplicationFonts, isActualComponentQueueFixture, isConstructionCostSnapshotFixture, isLocalOnlyStage623Fixture } from './e2e/fixtureEntrypointAssets';

const localOnlyStage623Fixture = isLocalOnlyStage623Fixture();
const constructionCostSnapshotFixture = isConstructionCostSnapshotFixture();
const actualComponentQueueFixture = isActualComponentQueueFixture();

if (localOnlyStage623Fixture) {
  require('./e2e/davisBaconScheduleFixture.css');
} else {
  require('./index.css');
  installRemoteApplicationFonts();
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      {process.env.REACT_APP_E2E_FIXTURE === 'contract-schedule'
        ? <ContractScheduleGanttFixture />
        : process.env.REACT_APP_E2E_FIXTURE === 'post-award-option-planning'
          ? <PostAwardOptionPlanningFixture />
          : constructionCostSnapshotFixture
            ? <ConstructionCostSnapshotFixture />
            : actualComponentQueueFixture
              ? <ActualComponentQueueFixture />
            : localOnlyStage623Fixture
              ? <DavisBaconScheduleFixture />
              : <App />}
    </ErrorBoundary>
  </React.StrictMode>
);
